import React from 'react';
import { useAccountContext } from 'contexts/account';
import { Text } from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { Container, Page } from 'styles';
import { BackLink } from 'components/back-link';
import { StandardRow } from 'components/standard-row';
import { MAX_SECONDARY_PAGE_WIDTH } from 'domain/style';

const getCopy = copyFor('settings.accountDetails');
const { accountNickname, settings } = routes();

export const AccountDetails = () => {
  const { selectedAccount } = useAccountContext();
  const { name, accountNumber } = selectedAccount;

  return (
    <>
      <BackLink to={settings} />
      <Page maxWidth={MAX_SECONDARY_PAGE_WIDTH}>
        <Container flex justifyContent="space-between">
          <Text textStyle="heading800" tag="h1" margin={{ bottom: '48px' }}>
            {getCopy('title')}
          </Text>
        </Container>
        <StandardRow
          heading={getCopy('accountNumber.label')}
          text={getCopy('accountNumber.copy', { accountNumber })}
          notranslate={true}
        />
        <StandardRow
          heading={getCopy('nickname.label')}
          text={name || undefined}
          iconLinkProps={{
            margin: '0px',
            to: accountNickname,
          }}
          hasBottomBorder={true}
          notranslate={true}
        />
      </Page>
    </>
  );
};
